import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseDiscountCode() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      discountCode: isEmpty(state.discountCode),
    };
    setter(errorState);

    if (errorState.discountCode) {
      enqueueSnackbar("لطفا کد تخفیف را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getDiscountCode = (myPC, search, searchColumn, callback) => {
    let newMypc = myPC;
    if (myPC.sortColumn == "ShamsiLogdate") {
      newMypc.sortColumn = "Logdate";
    }

    if (searchColumn) {
      newMypc.searchColumn = searchColumn;
    } else {
      newMypc.searchColumn = "";
    }
    MyAxios.get(`Admin_DiscountManagment/Code?w=${search}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: newMypc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const RandomDiscountCode = (callback) => {
    MyAxios.get(`Admin_DiscountManagment/Code/Instance`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCodeCandidate = (myPC, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Code/Candidate`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getDiscountCodeById = (Id, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Code/${Id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const editDiscountCode = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_DiscountManagment/Code`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کد تخفیف با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addDiscountCode = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Code`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کد تخفیف با موفقیت ایجاد شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteDiscountCode = (DiscountID, callback) => {
    const data = new FormData();
    data.append("DiscountID", JSON.stringify(DiscountID));
    MyAxios.delete(`Admin_DiscountManagment/Code`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کد تخفیف حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const UpdateDiscountCode = (callback) => {
    MyAxios.post(`Admin_DiscountManagment/Code/clear`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت به‌روز رسانی شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  /////////////////////////////////////////    User   ////////////////////////////////////////////////////

  const getDiscountCodeUser = (myPC, search, DiscountID, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Code/User/${DiscountID}?w=${search}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addDiscountCodeUser = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Code/User`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کاربر باموفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addDiscountCodeUsers = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Code/Users`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کاربران باموفقیت افزوده شدند", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteDiscountCodeUser = (DiscountUserID, callback) => {
    const data = new FormData();
    data.append("DiscountUserID", JSON.stringify(DiscountUserID));
    MyAxios.delete(`Admin_DiscountManagment/Code/User`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کاربر باموفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteAllDiscountCodeUser = (DiscountID, callback) => {
    const data = new FormData();
    data.append("DiscountID", JSON.stringify(DiscountID));
    MyAxios.delete(`Admin_DiscountManagment/Code/alluser`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کاربران باموفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  /////////////////////////////////////////    Product   ////////////////////////////////////////////////////

  const getDiscountCodeProduct = (DiscountID, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Code/Product/${DiscountID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const addDiscountCodeProduct = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Code/Product`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("محصول باموفقیت افزوده شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteDiscountCodeProduct = (DiscountProductID, callback) => {
    const data = new FormData();
    data.append("DiscountProductID", JSON.stringify(DiscountProductID));
    MyAxios.delete(`Admin_DiscountManagment/Code/Product`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("محصول باموفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  /////////////////////////////////////////    Brand   ////////////////////////////////////////////////////

  const getDiscountCodeBrand = (DiscountID, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Code/Brand/${DiscountID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const addDiscountCodeBrand = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Code/Brand`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("برند باموفقیت افزوده شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteDiscountCodeBrand = (DiscountBrandID, callback) => {
    const data = new FormData();
    data.append("DiscountBrandID", JSON.stringify(DiscountBrandID));
    MyAxios.delete(`Admin_DiscountManagment/Code/Brand`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("برند باموفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  /////////////////////////////////////////    Group   ////////////////////////////////////////////////////

  const getDiscountCodeGroup = (DiscountID, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Code/Group/${DiscountID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const addDiscountCodeGroup = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Code/Group`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("برند باموفقیت افزوده شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteDiscountCodeGroup = (DiscountGroupID, callback) => {
    const data = new FormData();
    data.append("DiscountGroupID", JSON.stringify(DiscountGroupID));
    MyAxios.delete(`Admin_DiscountManagment/Code/Group`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("برند باموفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  /////////////////////////////////////////    Category   ////////////////////////////////////////////////////

  const getDiscountCodeCategory = (DiscountID, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Code/Category/${DiscountID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const addDiscountCodeCategory = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Code/Category`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("برند باموفقیت افزوده شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteDiscountCodeCategory = (DiscountCategoryID, callback) => {
    const data = new FormData();
    data.append("DiscountCategoryID", JSON.stringify(DiscountCategoryID));
    MyAxios.delete(`Admin_DiscountManagment/Code/Category`, {
      data: data,
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("برند باموفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  /////////////////////////////////////////    sms   ////////////////////////////////////////////////////

  const getDiscountCodesms = (callback) => {
    MyAxios.get(`Admin_DiscountManagment/sms`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addDiscountCodesms = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Code/sms`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    getDiscountCode,
    getDiscountCodeById,
    RandomDiscountCode,
    editDiscountCode,
    addDiscountCode,
    deleteDiscountCode,
    getCodeCandidate,
    getDiscountCodeUser,
    addDiscountCodeUser,
    addDiscountCodeUsers,
    deleteDiscountCodeUser,
    getDiscountCodeProduct,
    addDiscountCodeProduct,
    deleteDiscountCodeProduct,
    getDiscountCodeBrand,
    addDiscountCodeBrand,
    deleteDiscountCodeBrand,
    getDiscountCodeGroup,
    addDiscountCodeGroup,
    deleteDiscountCodeGroup,
    getDiscountCodeCategory,
    addDiscountCodeCategory,
    deleteDiscountCodeCategory,
    getDiscountCodesms,
    addDiscountCodesms,
    deleteAllDiscountCodeUser,
    UpdateDiscountCode,
  };
}
